cv.DashboardView = Marionette.LayoutView.extend({
  className: "page-dashboard",

  getTemplate: function () {
    return cv.Templates["dashboard/view"];
  },

  regions: {
    my_progress: "#my-progress",
    team_progress: "#team-progress",
  },

  bindings: {
    ":el": {
      observe: ["photo_path", "team"],
      update: function ($el, value, model, options) {
        // Fundraiser profile photo
        var $replace_p = $el.find(".profile-photo").clone();

        $replace_p.attr(
          "data-src",
          cv.photo({
            photo_path: model.get("user.photo_path"),
            photo_default: cv.campaign.get("default_fundraiser_photo"),
            url_only: true,
            transforms: {
              fit: "crop",
            },
          })
        );

        $el.find(".profile-photo").replaceWith($replace_p);

        setTimeout(
          _.bind(function () {
            imgix.fluid($el.get(0), {
              updateOnResizeDown: false,
              pixelStep: 5,
              autoInsertCSSBestPractices: true,
            });
          }, this),
          50
        );

        // Team profile photo
        var $replace_t = $el.find(".team-profile-photo").clone();

        $replace_t.attr(
          "data-src",
          cv.photo({
            photo_path: model.get("team.photo_path"),
            photo_default: cv.campaign.get("default_team_photo"),
            url_only: true,
            transforms: {
              fit: "crop",
            },
          })
        );

        $el.find(".team-profile-photo").replaceWith($replace_t);

        setTimeout(
          _.bind(function () {
            imgix.fluid($el.get(0), {
              updateOnResizeDown: false,
              pixelStep: 5,
              autoInsertCSSBestPractices: true,
            });
          }, this),
          50
        );
      },
    },
  },

  events: {},

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    console.log("DashboardView initialized");
  },

  templateHelpers: function () {
    return {
      url: cv.project.get("url"),
      display_name: cv.project.get("display_name"),
      enable_teams: cv.campaign.get("enable_teams") == 1 ? true : false,
      has_toolkit: cv.campaign.get("project_toolkit_url") == "" ? false : true,
      project_toolkit_url: cv.campaign.get("project_toolkit_url"),
    };
  },

  onAttach: function () {
    this.stickit(cv.project);

    this.showChildView(
      "my_progress",
      new cv.DashboardProgressView({
        type: "project",
        active: true,
        model: cv.project,
      })
    );

    // Render the teams list
    if (cv.campaign.get("enable_teams") == 1) {
      if (_.isUndefined(cv.project.get("team.id"))) {
        this.$("#team-progress").html(cv.Templates["dashboard/no_team"]());
      } else {
        this.$("#team-progress").html(cv.Templates["dashboard/team_loading"]());

        var team_model = new cv.Team({
          id: cv.project.get("team.id"),
        });

        team_model.fetch({
          success: _.bind(function () {
            this.showChildView(
              "team_progress",
              new cv.DashboardProgressView({
                type: "team",
                active: false,
                model: team_model,
              })
            );
          }, this),
        });
      }
    }
  },
});
